import { createProvider } from './../vue-apollo'
import VueApollo from 'vue-apollo'
import Vue from 'vue'

Vue.use(VueApollo)

const apolloProvider = createProvider()
const apollo = apolloProvider.defaultClient

export default apollo